var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoResults(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "64px",
    height: "64px",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0, 0)",
    fillOpacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#A67C52",
    d: "M24,46c-1.10449,0-2-0.89551-2-2v-6c0-1.10449,0.89551-2,2-2s2,0.89551,2,2v6C26,45.10449,25.10449,46,24,46 z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DA34D",
    d: "M14.89453,3.55273c-0.33887-0.67773-1.4502-0.67773-1.78906,0l-10,20 c-0.15479,0.31006-0.13818,0.67822,0.04395,0.97314C3.33154,24.82031,3.65332,25,4,25h12.125c0.55225,0,1-0.44775,1-1 c0-0.40955-0.24756-0.75958-0.60004-0.91418l2.87946-6.58154c0.26239,0.11469,0.56616,0.12848,0.84265-0.00964 c0.49414-0.24707,0.69434-0.84766,0.44727-1.3418L14.89453,3.55273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4DA34D",
    d: "M44.89453,23.55273l-10-20c-0.33887-0.67773-1.4502-0.67773-1.78906,0l-5.7998,11.6001 c-0.24707,0.49414-0.04688,1.09473,0.44727,1.3418c0.27698,0.13806,0.58051,0.12408,0.84259,0.0094l2.87952,6.58179 C31.12256,23.24042,30.875,23.59045,30.875,24c0,0.55225,0.44775,1,1,1H44c0.34668,0,0.66846-0.17969,0.85059-0.47412 C45.03271,24.23096,45.04932,23.86279,44.89453,23.55273z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#72C472",
    d: "M38,39H10c-0.3374,0-0.65234-0.17041-0.83691-0.45264s-0.21436-0.63916-0.0791-0.94824l14-32 C23.24316,5.23535,23.60254,5,24,5s0.75684,0.23535,0.91602,0.59912l14,32c0.13525,0.30908,0.10547,0.66602-0.0791,0.94824 S38.3374,39,38,39z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoResults);
export default __webpack_public_path__ + "static/media/no-results.6cf8bf70.svg";
export { ForwardRef as ReactComponent };